module.exports = __webpack_public_path__ + "img/bcg4.8c7712c4.jpg";